export default __webpack_public_path__ + "static/media/xv.14680f09.jpg";